import moment from "moment";
export interface iWebUrls {
  staging: string;
  development: string;
  production: string;
}
export const WEB_URLS = {
  staging: "https://stage.myrepapp.com/",
  development: "http://localhost:3000/",
  production: "https://myrepapp.com/",
};
export const CLIENT_NAVIGATION = [
  "Personal Information",
  "Contact Information",
  "Your Location",
  "Food Preferences",
  "Office Policies",
];
export const REP_NAVIGATION = [
  "Personal Information",
  "Contact Information",
  "Your Location",
  "Products List",
];
export const ClientFormRules = {
  firstName: { required: true },
  lastName: { required: true },
  email: { required: true, email: true },
  phone: { required: true },
  url: { required: true, url: true },
  lineOne: { required: true },
  city: { required: true },
  zip: { required: true, zipCode: true },
  // fileUrl: { required: true },
  name: { required: true },
  timezone: { required: true },
};
export const timezoneOptions = moment.tz
  .names()
  .filter((name: string) => name.includes("US/"))
  .map((tz: string) => {
    return {
      label: tz,
      value: tz,
    };
  });

export const generateTimeOptions = () => {
  const times = [];
  for (let hour = 8; hour <= 17; hour++) {
    const label = `${hour > 12 ? hour - 12 : hour} ${hour >= 12 ? "pm" : "am"}`;
    times.push({ label, value: label });
  }
  return [...times, { label: "CALL ANY TIME", value: "CALL ANY TIME" }];
};

export const ALL_RELEASE_DATES_KEY = "ALL_RELEASE_DATES";
